import { ChatMockApi } from 'app/mock-api/apps/chat/api';
import { NavigationMockApi } from 'app/mock-api/common/navigation/api';
import { WorksMockApi } from './apps/works/api';

export const mockApiServices = [ChatMockApi, NavigationMockApi, WorksMockApi];
